const firebaseConfig = {
  apiKey: "AIzaSyA78gnVJYTm1cfa1_S7y0MHp1g3E2MHTfk",
  authDomain: "todo-list-app-5c488.firebaseapp.com",
  projectId: "todo-list-app-5c488",
  storageBucket: "todo-list-app-5c488.appspot.com",
  messagingSenderId: "254692848369",
  appId: "1:254692848369:web:4e0ec48c68c00a6b66af50",
};

export { firebaseConfig };
